import { entityGenderEnum, entityRoleEnum, entityTypeEnum, entityVerificationStatusEnum } from "../enums/entity.enum";

export const entityGender = [
  { label: "male", value: entityGenderEnum.MALE },
  { label: "female", value: entityGenderEnum.FEMALE },
];

export const entityVerificationStatus = [
  { label: "verified", value: entityVerificationStatusEnum.VERIFIED },
  { label: "unverified", value: entityVerificationStatusEnum.UNVERIFIED },
];

export const entityTypes = [
  {
    label: "professional_training_entity",
    value: entityTypeEnum.PROFESSIONAL_TRAINING_ENTITY,
  },
  { label: "sponsor_brand", value: entityTypeEnum.SPONSOR_BRAND },
  { label: "federation_entity", value: entityTypeEnum.FEDERATION_ENTITY },
  { label: "football_academy", value: entityTypeEnum.FOOTBALL_ACADEMY },
  { label: "School_or_university", value: entityTypeEnum.UNIVERSITY_OR_SCHOOL },
  { label: "football_club", value: entityTypeEnum.FOOTBALL_CLUB },
  { label: "other", value: entityTypeEnum.OTHER },
];

export const entityRoles = [
  { label: "Coach", value: entityRoleEnum.COACH },
  { label: "Scout", value: entityRoleEnum.SCOUT },
  { label: "Agent", value: entityRoleEnum.AGENT },
  { label: "Player", value: entityRoleEnum.PLAYER },
  { label: "Other", value: entityRoleEnum.OTHER },
];

export const numberOfMembersRanges = [
  {
    label: "1-10 members and professionals",
    value: "1-10 members and professionals",
  },
  {
    label: "11-50 members and professionals",
    value: "11-50 members and professionals",
  },
  {
    label: "51-200 members and professionals",
    value: "51-200 members and professionals",
  },
  {
    label: "51-200 members and professionals",
    value: "51-200 members and professionals",
  },
  {
    label: "201-500 members and professionals",
    value: "201-500 members and professionals",
  },
  {
    label: "501-1000 members and professionals",
    value: "501-1000 members and professionals",
  },
  {
    label: "1001-5000 members and professionals",
    value: "1001-5000 members and professionals",
  },
  {
    label: "+5000 members and professionals",
    value: "+5000 members and professionals",
  },
];
